<template>
  <!-- 组件 -->
  <div class="popup_code_page">
    <div class="popup_code_info" id="myImage" ref="codeInfo">
      <!-- 顶部 -->
      <div class="top_bg_logo">
        <div>
          <img src="@/assets/tms/logoicon.png" alt="" />
          <div>货源码货源</div>
        </div>
        <div class="title_text">邀请司机 扫码接单</div>
      </div>
      <div class="content_wrap">
        <div class="route_box">
          <div class="line_time_box">线路简称:{{ row.lineName || "--" }}</div>
          <div class="site_box">
            <!-- 装 -->
            <div class="site_each">
              <div class="site_line"></div>
              <img
                class="site_icon"
                src="@/assets/place-order/transport-start.png"
                alt=""
              />
              <div class="site_info">
                <div class="district">{{ info.shipperAddress || "" }}</div>
                <div class="position">
                  {{ info.shipperDetailAddress || "" }}
                </div>
              </div>
            </div>
            <!-- 卸 -->
            <div class="site_each">
              <img
                class="site_icon"
                src="@/assets/place-order/transport-end.png"
                alt=""
              />
              <div class="site_info">
                <div class="district">{{ info.consigneeAddress || "" }}</div>
                <div class="position">
                  {{ info.consigneeDetailAddress || "" }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 二维码区域 -->
        <div class="qr_box">
          <div class="qr_text_app">
            <span>打开</span>
            <span class="qr_text_app_name">【联帮帮司机端】</span>
            <span>App</span>
            <span>,点击</span>
            <span class="qr_text_app_name">扫码接单</span>
          </div>
          <img class="code_img" :src="codeUrl" alt="" />
          <div class="line_box_middle"></div>
          <div class="avant_wrap">
            <img
              class="user_icon"
              src="@/assets/place-order/user-img.png"
              alt=""
            />
            <div>
              <div class="avant_wrap_order_code">
                货源单号：{{ info.mainOrderNumber || "" }}
              </div>
              <div class="avant_wrap_company_name">
                {{ info.createdByName || "" }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 失效时间 -->
      <div class="expire_time">
        失效时间：{{ info.lastUnloadingTime || "" }}
      </div>
      <div class="info_top" v-if="false">
        <div class="info_time">
          失效时间：{{ info.lastUnloadingTime || "" }}
        </div>
      </div>
      <div class="info_details" v-if="false">
        <div class="company">合作公司：青岛民联科技发展有限公司</div>

        <div class="code_company">
          <div class="company_box">
            <div class="company_type">{{ info.coalBigTypeName || "" }}</div>
            <div class="company_user">
              <!-- <img
                class="user_icon"
                src="@/assets/place-order/user-img.png"
                alt=""
              /> -->
            </div>
          </div>
          <!-- <div class="code_box">
            <img class="code_img" :src="codeUrl" alt="" />
          </div> -->
        </div>
        <div class="warn">
          打开<span class="warn_company">联帮帮司机端App</span> -
          点击首页扫码接单
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import html2canvas from "html2canvas";
export default {
  props: {
    value: {
      type: String,
      default: ""
    },
    codeUrl: {
      type: String,
      default: ""
    },
    info: {
      type: Object,
      default: {}
    },
    row: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {};
  },
  //过滤器
  filters: {},
  // 计算属性
  computed: {},
  // 监听器
  watch: {},
  //生命周期 创建后
  created() {},
  // 挂载后
  mounted() {},
  // 销毁前
  beforeDestroy() {},
  //自定义函数
  methods: {
    async down() {
      try {
        const setup = {
          useCORS: true // 使用跨域
        };
        const canvas = await html2canvas(this.$refs.codeInfo, setup); // 在这里，将需要转换成图片的部分作为参数传入html2canvas
        console.log("canvas", canvas);
        const image = canvas.toDataURL("image/png"); // 将生成的canvas转换为DataURL格式
        let imgUrl = image;
        let eleLink = document.createElement("a");
        eleLink.download = "image.png";
        eleLink.href = imgUrl;
        eleLink.click();
        eleLink.remove();
        this.$emit("closeCode");
      } catch (e) {
        throw new Error(e);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.expire_time {
  width: 340px;
  height: 70px;
  background: url("~@/assets/tms/img_bg.png") no-repeat left center;
  background-size: 100% 100%;
  padding-left: 20px;
  font-weight: 600;
  font-size: 16px;
  color: #ffffff;
  text-align: center;
  line-height: 86px;
}
.avant_wrap {
  display: flex;
  margin-top: 27px;
  .user_icon {
    width: 40px;
    height: 40px;
    margin-right: 10px;
  }
  .avant_wrap_order_code {
    font-weight: 500;
    font-size: 14px;
    color: #333333;
  }
  .avant_wrap_company_name {
    font-weight: 400;
    font-size: 13px;
    color: #777777;
  }
}
.qr_box {
  width: 310px;
  height: 410px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #ffffff;
  .line_box_middle {
    width: 212px;
    height: 0px;
    border: 1px dotted #d9d9d9;
  }
  .qr_text_app {
    width: 297px;
    height: 45px;
    text-align: center;
    line-height: 45px;
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #000000;
    margin-top: 20px;
    span {
      font-weight: 600;
      font-size: 13px;
      color: #171433;
    }
    .qr_text_app_name {
      font-weight: 600;
      font-size: 13px;
      color: #4570f1;
    }
  }
  .code_img {
    width: 237px;
    height: 237px;
  }
}
.content_wrap {
  padding-top: 20px;
  padding-left: 13px;
  .route_box {
    padding-left: 13px;
    .line_time_box {
      font-weight: bold;
      font-size: 18px;
      color: #4186ef;
    }
  }
}
.site_box {
  margin-top: 15px;
  padding-left: 20px;
  box-sizing: border-box;
  .site_each {
    display: flex;
    position: relative;
    .site_line {
      position: absolute;
      top: 20px;
      left: 9px;
      bottom: 0px;
      border: 1px dotted #aaaaaa;
    }
    .site_icon {
      width: 20px;
      height: 20px;
      margin-right: 15px;
    }
    .site_info {
      .district {
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 500;
        font-size: 16px;
        color: #000000;
      }
      .position {
        width: 260px;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        font-size: 16px;
        color: #777777;
        margin-top: 4px;
        height: 44px;
        box-sizing: border-box;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}

.popup_code_page {
  position: fixed;
  top: 100000px;
  left: 290px;
  z-index: 999;
  width: 0;
  height: 0;
  overflow: hidden;
  .popup_code_info {
    width: 339px;
    min-height: 490px;
    background: #ffffff;
    // border-radius: 19px 19px 19px 19px;
    // border: 2px solid #eff2ef;
    // background-image: url("../../assets/place-order/code-back.png");
    // background-size: 100% 100%;
    .top_bg_logo {
      width: 100%;
      height: 104px;
      background: linear-gradient(232deg, #426df0 0%, #6994fc 100%);
      padding: 20px 20px 23px;
      .title_text {
        font-weight: bold;
        font-size: 28px;
        color: #ffffff;
        margin-top: 14px;
        margin-left: 35px;
      }
      div {
        display: flex;
        justify-content: space-between;
        img {
          width: 125px;
          height: 12px;
        }
        div {
          font-weight: bold;
          font-size: 13px;
          color: #ffffff;
          line-height: 9px;
        }
      }
    }
    .info_top {
      height: 250px;
      width: 100%;

      .top_title {
        padding-top: 20px;
        box-sizing: border-box;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 800;
        font-size: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        .title_one {
          color: #333333;
          margin-right: 8px;
        }
        .title_two {
          color: #4186ef;
        }
      }
      .info_time {
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: bold;
        font-size: 14px;
        color: #777777;
        text-align: center;
      }
    }
    .info_details {
      height: 240px;
      width: 100%;
      padding: 3px 0 0 20px;
      box-sizing: border-box;
      .company {
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        font-size: 14px;
        color: #777777;
      }
      .order_code {
        margin-top: 3px;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        font-size: 14px;
        color: #777777;
      }
      .code_company {
        display: flex;
        justify-content: space-between;
        padding-right: 16px;
        box-sizing: border-box;
        margin-top: 3px;
        .company_box {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          .company_type {
            border-radius: 57px 57px 57px 57px;
            border: 1px solid #4186ef;
            padding: 0 12px;
            display: flex;
            align-items: center;
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 400;
            font-size: 14px;
            color: #4186ef;
            max-width: 160px;
          }
          .company_user {
            margin-top: 20px;
            display: flex;
            align-items: center;
            .user_icon {
              width: 40px;
              height: 40px;
              margin-right: 10px;
              border-radius: 40px;
            }
            .company_name {
              font-family: Source Han Sans CN, Source Han Sans CN;
              font-weight: 400;
              font-size: 14px;
              color: #333333;
              width: 134px;
            }
          }
        }
        .code_box {
          width: 160px;
          height: 160px;
          border-radius: 8px 8px 8px 8px;
          border: 1px solid #d9d9d9;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          .code_img {
            width: 175px;
            height: 175px;
          }
        }
      }
      .warn {
        margin-top: 3px;
        text-align: center;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: bold;
        font-size: 13px;
        color: #aaaaaa;
        .warn_company {
          color: #333;
        }
      }
    }
  }
}
</style>
